import { useEffect, useRef } from 'react';
import { useMap } from 'react-leaflet';

export default function FitImageBounds({ bounds }) {
  const map = useMap();
  const hasFitted = useRef(false);
  useEffect(() => {
    if (!hasFitted.current) {
      map.fitBounds(bounds);
      hasFitted.current = true;
    }
  }, [map, bounds]);
  return null;
}
